'use es6';

import { memo } from 'react';
import { translateObjectName } from 'customer-data-objects/record/translateObjectName';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { calleeName } from 'calling-lifecycle-internal/callees/utils/calleeName';
import { getObjectType } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
function CalleeObjectGroupOption({
  callableObject,
  objectTypeId
}) {
  const calleeObjectName = calleeName(callableObject);
  const callableObjectType = getObjectType(callableObject);
  const text = callableObjectType && callableObjectType !== ObjectTypeFromIds[objectTypeId] ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "callee-selection.objectGroupHeader",
    options: {
      name: calleeObjectName,
      objectType: translateObjectName(callableObjectType)
    }
  }) : calleeObjectName;
  return /*#__PURE__*/_jsx("div", {
    className: "is--heading-7 p-left-4 m-bottom-1 p-right-4",
    children: text
  });
}
export default /*#__PURE__*/memo(CalleeObjectGroupOption);